import {Component, OnInit} from '@angular/core';
import {Brand} from '../brand/brand.model';
import {BrandService} from '../brand/brand.service';
import {ModelGroup} from './model-group.model';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ModelGroupService} from './model-group.service';

@Component({
  selector: 'app-model-group',
  templateUrl: './model-group.component.html',
  styleUrls: ['./model-group.component.css']
})
export class ModelGroupComponent implements OnInit {

  form: UntypedFormGroup;
  brands: Array<Brand>;
  modelGroups: Array<ModelGroup> = [];


  constructor(private brandService: BrandService, private formBuilder: UntypedFormBuilder, private service: ModelGroupService) {
    this.form = formBuilder.group({
      make: new UntypedFormControl(),
      code: new UntypedFormControl()
    });
  }

  ngOnInit(): void {
    this.brandService.all().subscribe((brands: Array<Brand>) => {
      this.brands = brands;
    });

    this.service.findAll().subscribe((modelGroups: ModelGroup[]) => {
      this.modelGroups = modelGroups;
    });
  }

  addModelGroup(): void {
    const modelGroup: ModelGroup = {
      id: undefined, startDate: new Date(), code: undefined, createdOn: new Date(),
      description: undefined, make: undefined
    };

    this.modelGroups.unshift(modelGroup);
  }

  clearOne(modelGroup: ModelGroup): void {
    const i: number = this.modelGroups.findIndex((subject) => subject === modelGroup);
    this.modelGroups.splice(i, 1);
  }

  findByCode(): void {
    this.modelGroups = [];

    this.service.findByCode(this.form.get('code').value).subscribe((modelGroup: ModelGroup) => {
      if (modelGroup) {
        this.modelGroups = [modelGroup];
      }
    });
  }

  findByMake(): void {
    this.modelGroups = [];

    this.service.findByMakeName(this.form.get('make').value).subscribe((modelGroups: Array<ModelGroup>) => {
      this.modelGroups = modelGroups;
    });
  }

  clear(): void {
    this.form.setValue({make: '', code: ''});
    this.ngOnInit();
  }

  search(): void {
    if (this.form.get('make').value) {
      this.findByMake();
    } else if (this.form.get('code').value) {
      this.findByCode();
    }
  }
}
